var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from 'classnames';
import { default as React, useState } from 'react';
import { displayError } from '../Config/ApplicationConfig';
import { iconLight } from '../Styles/Colours';
import { Button, ButtonMode } from '../Components/Button';
import { MedicationCard, MedicationCardMode } from '../Components/MedicationCard';
import { RefreshIcon, StopHandIcon, TrashCanIcon } from '../Components/Icons';
import { MedicationExpiry, MedicationStatus, MedicationType, PatientMedicationAllowedAction } from '../Contracts/MedicationModels';
import { expiryStatusFromDate } from '../Shared/MedicationsHelpers';
import { DeleteMedicationDialog } from './DeleteMedicationDialog';
import styles from './MedicationsSummaryListActions.module.css';
import { ReprescribeSingleMedicationDialog } from '../ReprescribeMedication/ReprescribeSingleMedicationDialog';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { PermissionsCheck } from '../Components/Auth/PermissionsCheck';
import { buttonVariantColour } from './Utilities';
import { usePermissions } from '../Hooks/usePermissions';
import { ReprescribeFreeTextMedication } from '../ReprescribeMedication/ReprescribeFreeTextMedication';
import { MedicationStatusIcon } from './MedicationStatusIcon';
export var MedicationsSummaryListActions = function (props) {
    var _a;
    var selected = props.item.lastMedication.id === props.selectedId;
    var expiryStatus = expiryStatusFromDate(props.item.lastMedication.expiresOn);
    var stopped = props.item.lastMedication.status === MedicationStatus.Stopped;
    var expired = !stopped && expiryStatus === MedicationExpiry.Expired;
    var aboutToExpire = !stopped && expiryStatus === MedicationExpiry.AboutToExpire;
    var cardClasses = classNames(styles.cardContainer, (_a = {},
        _a[styles.selected] = selected,
        _a[styles.expired] = expired,
        _a[styles.aboutToExpire] = aboutToExpire,
        _a));
    var _b = __read(useState(false), 2), showDeleteMedicationDialog = _b[0], setShowDeleteMedicationDialog = _b[1];
    var _c = __read(useState(false), 2), showReprescribeSingleMedicationDialog = _c[0], setShowReprescribeSingleMedicationDialog = _c[1];
    var _d = __read(useState(null), 2), represcribeMedication = _d[0], setReprescribeMedication = _d[1];
    var permissions = usePermissions({
        stopMedications: MedicationsPermissions.StopMedications,
        prescribeMedicationsTakeHomeScript: MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        prescribeMedicationsEnrmcScript: MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        prescribeMedicationsMedicationOrder: MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        prescribeMedicationsMedicationHistory: MedicationsPermissions.PrescribeMedicationsMedicationHistory,
        prescribeComplementaryTherapyOrder: MedicationsPermissions.PrescribeComplementaryTherapyOrder
    });
    var canReprescribe = [
        permissions.prescribeMedicationsTakeHomeScript,
        permissions.prescribeMedicationsEnrmcScript,
        permissions.prescribeMedicationsMedicationOrder,
        permissions.prescribeMedicationsMedicationHistory,
        permissions.prescribeComplementaryTherapyOrder
    ].filter(Boolean).length > 0 && !!permissions.stopMedications;
    var actionButton = function () {
        var allowedActions = props.item.allowedActions;
        if (!allowedActions || allowedActions.length === 0)
            return;
        if (allowedActions.includes(PatientMedicationAllowedAction.Delete))
            return (React.createElement(Button, { onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowDeleteMedicationDialog(true);
                }, iconOnly: true, noShadowOnHover: true, mode: ButtonMode.text, tooltip: 'Delete', testId: 'menuItem_DeleteMedication', subtleShadeOnHover: true, variant: buttonVariantColour(selected, expired, aboutToExpire) },
                React.createElement(TrashCanIcon, { color: iconLight, size: '16' })));
        if (allowedActions.includes(PatientMedicationAllowedAction.Stop))
            return (React.createElement(PermissionsCheck, { key: 'stop-medication', permission: MedicationsPermissions.StopMedications },
                React.createElement(Button, { onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        props.stopMedication(props.item.lastMedication.id);
                    }, iconOnly: true, noShadowOnHover: true, mode: ButtonMode.text, tooltip: 'Stop', testId: 'menuItem_StopMedication', subtleShadeOnHover: true, variant: buttonVariantColour(selected, expired, aboutToExpire) },
                    React.createElement(StopHandIcon, { color: iconLight, size: '24' }))));
        if (allowedActions.includes(PatientMedicationAllowedAction.Represcribe) && canReprescribe)
            return (React.createElement(Button, { onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    props.canReprescribe(function () {
                        var _a, _b, _c;
                        props.item.lastMedication.type === MedicationType.MedicationHistory &&
                            props.item.isFreeTextMedication
                            ? setReprescribeMedication({
                                patientMedication: props.item.lastMedication,
                                text: (_c = (_b = (_a = props.item) === null || _a === void 0 ? void 0 : _a.productPack) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : ''
                            })
                            : setShowReprescribeSingleMedicationDialog(true);
                    });
                }, iconOnly: true, noShadowOnHover: true, mode: ButtonMode.text, tooltip: 'Re-prescribe', testId: 'menuItem_ReprescribeMedication', subtleShadeOnHover: true, variant: buttonVariantColour(selected, expired, aboutToExpire) },
                React.createElement(RefreshIcon, { color: iconLight, size: '24' })));
        return;
    };
    var handleCloseReprescribeDialog = function () {
        setReprescribeMedication(null);
        setShowReprescribeSingleMedicationDialog(false);
    };
    // TODO: This needs to be de-duped
    var handleFreeTextMedicationSelection = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var ids, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, props.saveFreeTextMedicationToReprescribe(config)];
                case 1:
                    ids = _a.sent();
                    setReprescribeMedication(null);
                    if (ids.medications.length) {
                        props.onReprescribe(ids.medications[0]);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    displayError('Unable to represcribe');
                    setReprescribeMedication(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cardClasses, key: props.item.lastMedication.id, onClick: function (event) { return props.onClick(event, props.item.lastMedication.id); } },
            React.createElement(MedicationStatusIcon, { medicationStatus: props.item.lastMedication.status }),
            React.createElement(MedicationCard, { name: props.item.productPack.name, strength: props.item.productPack.strength, strengthUnit: props.item.productPack.strengthUnit, selected: selected, type: props.item.lastMedication.type, size: props.item.productPack.size, productPackAmount: props.item.lastMedication.productPackAmount, repeatsAmount: props.item.lastMedication.repeatsAmount, mode: MedicationCardMode.Condensed, isNonStandardPackSize: props.item.lastMedication.isNonStandardPackSize, nonStandardPackSize: props.item.lastMedication.nonStandardPackSize }),
            React.createElement("div", { className: styles.action }, actionButton())),
        showDeleteMedicationDialog && (React.createElement(DeleteMedicationDialog, { medicationName: props.item.productPack.name, medicationId: props.item.lastMedication.id, onDelete: props.onDelete, setShowDeleteMedicationDialog: function (show) { return setShowDeleteMedicationDialog(show); } })),
        showReprescribeSingleMedicationDialog && (React.createElement(ReprescribeSingleMedicationDialog, { serviceAuthoringSystem: props.serviceAuthoringSystem, serviceAuthoringSystemForeignKey: props.serviceAuthoringSystemForeignKey, medicationName: props.item.productPack.name, lastMedication: {
                medication: props.item.lastMedication,
                productPack: props.item.productPack
            }, patient: props.patient, saveMedicationsToReprescribe: props.saveMedicationsToReprescribe, onClose: handleCloseReprescribeDialog, controlledMedicationHandler: props.controlledMedicationHandler, onReprescribe: props.onReprescribe })),
        represcribeMedication && (React.createElement(ReprescribeFreeTextMedication, { patientMedication: represcribeMedication.patientMedication, freeText: represcribeMedication.text, onSelectionMedication: handleFreeTextMedicationSelection, onClose: function () { return setReprescribeMedication(null); } }))));
};
